import React from "react";
import "./PdfDownloader.scss";
import eventTracking from "../../utils/eventTracking";

function PdfDownloader(props) {
  let text = "Last ned hele kapittelet";
  // custom text if set
  if (props.text) {
    text = props.text;
  }
  function onClick(pdf) {
    eventTracking(
      'Last ned',
      'PDF',
      pdf
    )
  }
  return (
    <div className="pdf-downloader">
      <a
        href={require("../../assets/pdf/Barnas_Skog_" + props.pdf + ".pdf")}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onClick(props.pdf)}
      >
        {text}
      </a>
    </div>
  );
}

export default PdfDownloader;
